import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Átomo: botón flotante de soporte por WhatsApp.
 * Presentacional: enlace + imagen, sin lógica de negocio.
 */
@Component({
  selector: 'ui-whatsapp-fab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './whatsapp-fab.component.html',
  styleUrl: './whatsapp-fab.component.scss',
  host: {
    class: 'ui-whatsapp-fab-host',
  },
})
export class UiWhatsappFabComponent {
  /** URL de WhatsApp (p. ej. https://wa.me/523347151793) */
  readonly href = input.required<string>();

  /** Etiqueta accesible del enlace */
  readonly ariaLabel = input('Contactar soporte por WhatsApp');

  /** Imagen del botón */
  readonly imageSrc = input('/images/whatsapp.png');

  /** Texto alternativo de la imagen */
  readonly imageAlt = input('WhatsApp');
}
